/*! @azure/msal-browser v4.7.0 2025-03-11 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "4.7.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
